import { Button, Col, Div, Row, Text } from "atomize"
import { theme } from "../settings/config"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { DateTime } from "luxon"
import { motion } from "framer-motion"
import { isSmartphone } from "../atoms/SmartphoneView"
import { ABOVE_PHONE_NAV } from "../atoms/phoneBars"
import { getDayOfWeek } from "../utils/func.utils"
import DateInput from "../inputs/DateInput"
import PhoneCoachDropdown from "./PhoneCoachDropdown"

function ProfileDateBar({ summaryDate, setSummaryDate, hint }) {
	return (
		<Div d="flex" justify="center">
			<motion.div
				style={
					isSmartphone
						? {
								position: "fixed",
								bottom: ABOVE_PHONE_NAV,
								transform: "translateX(-50%)",
								width: "calc(100% - 2rem)",
								zIndex: "1",
							}
						: {
								position: "fixed",
								width: "25rem",
								bottom: "5rem",
								zIndex: "1",
							}
				}
				initial={{ y: 20 }}
				animate={{ y: 0 }}
				exit={{ y: 100, opacity: 0 }}>
				<PhoneCoachDropdown />
				{/* un gesto che non si vede, detto le prime volte: come quelli
				    delle lezioni, nello stesso posto e nello stesso modo */}
				{hint && (
					<Text
						textSize="caption"
						textAlign="center"
						textColor={theme.colors.text_light}
						m={{ x: "auto", b: "0.4rem" }}
						p="0.2rem 0.75rem"
						w="fit-content"
						rounded="12px"
						bg={theme.colors.surface}
						// qui passa sopra le schede, bianche come lui: l'ombra lo stacca
						shadow={theme.shadows.accent}>
						{hint}
					</Text>
				)}
				<Row
					pos="relative"
					p={{ y: "0.5rem", x: "0.25rem" }}
					bg={theme.colors.primary_light}
					rounded={theme.rounded["20px"]}>
					<Col size="2" style={{ padding: "0 0.25rem" }}>
						<motion.div whileTap={{ scale: 0.9 }}>
							<Button
								w="3.25rem"
								h="3.25rem"
								m="auto"
								bg={theme.colors.surface}
								shadow={theme.shadows.accent}
								rounded={theme.rounded["20px"]}
								onClick={() =>
									setSummaryDate({
										start: summaryDate.start.minus({ months: 1 }).startOf("month"),
										end: summaryDate.end.minus({ months: 1 }).endOf("month"),
									})
								}>
								<FontAwesomeIcon icon={faChevronLeft} color={theme.colors.gunmetal} />
							</Button>
						</motion.div>
					</Col>

					<Col
						size="4"
						pos="relative"
						style={{ padding: "0 0.25rem" }}
						onClick={() => {
							const input = document.getElementById("summary_start_date_input")
							if (input.showPicker) input.showPicker()
							else input.click()
						}}>
						<Text
							d="flex"
							pos="relative"
							justify="center"
							align="center"
							h="3.25rem"
							textSize="subheader"
							textAlign="center"
							textColor={theme.colors.gunmetal}
							zIndex="1">
							{getDayOfWeek(summaryDate.start)}
						</Text>
						<Div pos="absolute" top="0" left="0" w="100%" h="100%" zIndex="2">
							<DateInput
								id="summary_start_date_input"
								w="100%"
								h="100%"
								opacity="0"
								m="0"
								shadow={theme.shadows.accent}
								value={summaryDate.start.toISO()?.split("T")[0]}
								max={summaryDate.end.toISODate()}
								min={summaryDate.end.minus({ months: 1, days: 10 }).toISODate()}
								handleChange={newStartDate => {
									const newStart = DateTime.fromISO(newStartDate)
									const maxEnd = newStart.plus({ months: 1, days: 10 })
									setSummaryDate(prev => {
										let newEnd = prev.end
										if (newEnd > maxEnd) newEnd = maxEnd
										if (newEnd < newStart) newEnd = newStart
										return { start: newStart, end: newEnd }
									})
								}}
							/>
						</Div>
					</Col>

					<Col
						size="4"
						pos="relative"
						style={{ padding: "0 0.25rem" }}
						onClick={() => {
							const input = document.getElementById("summary_end_date_input")
							if (input.showPicker) input.showPicker()
						}}>
						<Text
							d="flex"
							justify="center"
							align="center"
							h="3.25rem"
							textSize="subheader"
							textAlign="center"
							textColor={theme.colors.gunmetal}
							style={{ position: "relative", zIndex: 1 }}>
							{getDayOfWeek(summaryDate.end)}
						</Text>
						<Div pos="absolute" top="0" left="0" w="100%" h="100%" zIndex="2">
							<DateInput
								id="summary_end_date_input"
								w="100%"
								h="100%"
								opacity="0"
								m="0"
								shadow={theme.shadows.accent}
								value={summaryDate.end.toISO()?.split("T")[0]}
								min={summaryDate.start.toISODate()}
								max={summaryDate.start.plus({ months: 1, days: 10 }).toISODate()}
								handleChange={newEndDate => {
									const newEnd = DateTime.fromISO(newEndDate)
									setSummaryDate(prev => {
										let newStart = prev.start
										if (newEnd.diff(prev.start, "days").days > 40)
											newStart = newEnd.minus({ months: 1, days: 10 })
										if (newEnd < newStart) newStart = newEnd
										return { start: newStart, end: newEnd }
									})
								}}
							/>
						</Div>
					</Col>

					<Col size="2" style={{ padding: "0 0.25rem" }}>
						<motion.div whileTap={{ scale: 0.9 }}>
							<Button
								w="3.25rem"
								h="3.25rem"
								m="auto"
								bg={theme.colors.surface}
								shadow={theme.shadows.accent}
								rounded={theme.rounded["20px"]}
								onClick={() =>
									setSummaryDate({
										start: summaryDate.start.plus({ months: 1 }).startOf("month"),
										end: summaryDate.end.plus({ months: 1 }).endOf("month"),
									})
								}>
								<FontAwesomeIcon
									icon={faChevronRight}
									color={theme.colors.gunmetal}
								/>
							</Button>
						</motion.div>
					</Col>
				</Row>
			</motion.div>
		</Div>
	)
}

export default ProfileDateBar
